package amazon.lastmile.inject

import app.nestbridge.feature.children.presentation.ChildListPresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = ChildListPresenterFactory::class)
public interface AppNestbridgeFeatureChildrenPresentationChildListPresenterFactory {
  @Provides
  @IntoSet
  public fun provideChildListPresenterFactoryFactoryMultibinding(childListPresenterFactory: ChildListPresenterFactory): Presenter.Factory = childListPresenterFactory
}
